// src/lib/constants/feed.ts

import type { SortDirection } from '@/lib/types/common';
import type { FeedSortKey } from '@/lib/types/Feed';

// Feed constraints (match backend validation)
export const FEED_CONSTRAINTS = {
  TITLE_MIN: 1,
  TITLE_MAX: 150,
  DESC_SHORT_MAX: 300,
  SOURCE_TITLE_MIN: 1,
  SOURCE_TITLE_MAX: 150,
} as const;

// Feed formats for publish -- values match lib2 FeedFormat enum
export const FEED_FORMATS = ['mrss', 'Roku', 'firetv'] as const;
export type FeedFormat = typeof FEED_FORMATS[number];

export const FEED_FORMAT_LABELS: Record<FeedFormat, string> = {
  mrss: 'MRSS',
  Roku: 'Roku Direct Publisher',
  firetv: 'FireTV (Amazon Creator)',
} as const;

// iTunes explicit values -- lowercase per lib2 ITunesExplicit enum
export const ITUNES_EXPLICIT_VALUES = ['yes', 'no'] as const;
export type ITunesExplicitValue = typeof ITUNES_EXPLICIT_VALUES[number];

export const ITUNES_EXPLICIT_LABELS: Record<ITunesExplicitValue, string> = {
  yes: 'Yes',
  no: 'No',
} as const;

// Grid configuration -- canonical constants matching other grids
export const FEED_ROW_HEIGHT = 56;
export const FEED_VIRTUALIZER_OVERSCAN = 10;
export const FEED_GRID_MAX_VIRTUAL_ROWS = 72;
export const FEED_GRID_MAX_VIEWPORT_HEIGHT_PX = 2200;
// Sort defaults
export const DEFAULT_FEED_SORT_KEY: FeedSortKey = 'updated';
export const DEFAULT_FEED_SORT_DIRECTION: SortDirection = 'desc';
export const FEED_SORT_KEYS = ['title', 'status', 'created', 'updated'] as const;

// Query keys -- hierarchical tuple factory (separate from MEDIA_QUERY_KEYS since feeds aren't media)
export const FEED_QUERY_KEYS = {
  all: ['feeds'] as const,
  list: (cId: number) => [...FEED_QUERY_KEYS.all, 'list', cId] as const,
  detail: (cId: number, feedId: number) => [...FEED_QUERY_KEYS.list(cId), feedId] as const,
} as const;

// Grid column header definition
export interface FeedHeaderColumn {
  key: string;
  label: string;
  sortable: boolean;
  sortKey?: FeedSortKey;
  align?: 'left' | 'center' | 'right';
}

export const FEED_HEADER_COLUMNS: FeedHeaderColumn[] = [
  { key: 'checkbox', label: '', sortable: false },
  { key: 'title', label: 'Title', sortable: true, sortKey: 'title', align: 'left' },
  { key: 'status', label: 'Status', sortable: true, sortKey: 'status', align: 'center' },
  { key: 'created', label: 'Created', sortable: true, sortKey: 'created', align: 'right' },
  { key: 'updated', label: 'Updated', sortable: true, sortKey: 'updated', align: 'right' },
  { key: 'actions', label: '', sortable: false },
];
